import React, { Component } from "react";

import TAForm from "./TAForm";

export default class TAship extends Component {
  render() {
    return (
      <React.Fragment>
        <section>
          <div>
            <p>
              Teaching Assistanceship will help you finance your education. A teaching assistantship position is largely invaluable due to
              the academic/practical work experience and the networking benefits you'll gain.
            </p>
            <p>There are certain criteria that needs to be met in order to be eligible for a TA ship.</p>
            <p>
              You can apply for TAship even before you enter US. If you are enrolling to Fall semester you can apply for TA ship any time
              before April 30 and you will recieve the confirmation between May-July.
            </p>
            <p>
              Even if you do not get a TAship in the first semester, you can still apply for the later semester when the application is
              available.
            </p>
          </div>
          <hr />
        </section>
        <section>
          <header className="section_head">Eligibility criteria for TA ship</header>
          <br />
          <p>
            Use this link to get information:
            <a href="https://cs.uga.edu/graduate-financial-assistance" className="redLink" target={"_blank"} rel={"noreferrer"}>
              TA requirements
            </a>
          </p>
          <p>
            You can also check this PDF: &nbsp;&nbsp;
            <a
              href="https://ctl.uga.edu/_resources/documents/guide-to-demonstrating-english-language-proficiency-feb-2022.pdf"
              className="redLink"
              target={"_blank"}
              rel={"noreferrer"}
            >
              Guide to demonstrating Language proficiency
            </a>
          </p>
          <br />
          <u>There are three requirements:</u>
          <b>
            <ol>
              <li>
                Take the TA orientation quiz - this you can take before or after you get TA ship. If you just got admission the you can take
                this in first semester
              </li>
              <li>Take the course: GSRC 7770 - same condition as TA orientation</li>
              <li>Language Profieciency - This is needed for internation student. Details are given below:</li>
            </ol>
          </b>
          If you are an international student, you need to show minimum language proficiency required for TA ship. They are:
          <table className="table">
            <thead className="thead-dark">
              <tr>
                <th scope="col">#</th>
                <th scope="col">Test Name</th>
                <th scope="col">Minimum Score Required</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">1</th>
                <td>TOEFL Speaking</td>
                <td>{">="}26</td>
              </tr>
              <tr>
                <th scope="row">2</th>
                <td>IELTS Speaking</td>
                <td>{">="}8.0</td>
              </tr>
              <tr>
                <th scope="row">3</th>
                <td>Duolingo Overall Score</td>
                <td>{">="}135</td>
              </tr>
            </tbody>
          </table>
          <p>
            The above requirement may change in future. These are according to the year 2022. To check the details - use this link: &nbsp;
            <a href="https://ctl.uga.edu/grad-student/ta-policy/" className="redLink" target={"_blank"} rel={"noreferrer"}>
              TA POLICY
            </a>
          </p>
          <div>
            <ul>
              <li>You only need to provide results of one of the above tests even if you took multiple tests.</li>
              <li>If you meet at least one requirement, you are considered in placement level 4</li>
              <li>If you do not meet requirement, don't worry, there is still a few steps which I will discuss further</li>
            </ul>
          </div>
          <hr />
        </section>
        <section>
          <header className="section_head">What to do if you do not qualify according to the min requirement?</header>
          <br />
          <div>
            <li>One approach is you could take any of these exams again and try to meet the requirements.</li>
            <li>
              Since it is not practical for everyone we also have other option: There are two ways :
              <ol>
                <li>Give the ITA-TEP exam conducted by the university.</li>
                <li>
                  Give the duolingo test instead of ITA-TEP with the video interview and submit (This option is if the application
                  confirmation deadline is over - April 30 for Fall admissions)
                </li>
              </ol>
            </li>
            <li>
              <a
                href="https://resources.coe.uga.edu/students/international-teaching-assistant-testing/"
                className="redLink"
                target={"_blank"}
                rel={"noreferrer"}
              >
                International TA ship details
              </a>
            </li>
            <li>
              <a
                href="https://resources.coe.uga.edu/students/international-teaching-assistant-testing/#preparing-for-the-ita-tep"
                className="redLink"
                target={"_blank"}
                rel={"noreferrer"}
              >
                ITA - TEP details
              </a>
            </li>
            <li>
              <a
                href="https://resources.coe.uga.edu/students/international-teaching-assistant-testing/#who-needs-to-take-the-test"
                className="redLink"
                target={"_blank"}
                rel={"noreferrer"}
              >
                Check if you need to take the test
              </a>
            </li>
            <li>
              <a
                href="https://resources.coe.uga.edu/students/international-teaching-assistant-testing/#testing-dates-and-registration"
                className="redLink"
                target={"_blank"}
                rel={"noreferrer"}
              >
                Testing dates and registration
              </a>
            </li>
            <li>
              <a
                href="https://resources.coe.uga.edu/students/international-teaching-assistant-testing/#how-to-register"
                className="redLink"
                target={"_blank"}
                rel={"noreferrer"}
              >
                How to register
              </a>
            </li>
            <li>
              <a
                href="https://resources.coe.uga.edu/students/international-teaching-assistant-testing/#registering-for-the-ita-tep-assessment"
                className="redLink"
                target={"_blank"}
                rel={"noreferrer"}
              >
                ITA-TEP registration
              </a>
            </li>
            <li>
              <a
                href="https://resources.coe.uga.edu/students/international-teaching-assistant-testing/#registering-for-the-ita-tep-assessment"
                className="redLink"
                target={"_blank"}
                rel={"noreferrer"}
              >
                ITA-TEP registration
              </a>
            </li>
          </div>
          <hr />
        </section>
        <section>
          <header className="section_head">How to Apply for TA ship - process</header>
          <br />
          <p>By now if you followed all steps above you know, you are eligible or not. If you are, let's apply via the TA form</p>
          <p>
            The form can be found in this link (scroll down to 2.DEPARTMENTAL TEACHING ASSISTANTSHIPS and you can find the link) -
            <a href="https://cs.uga.edu/graduate-financial-assistance" className="redLink" target={"_blank"} rel={"noreferrer"}>
              TA form page
            </a>
          </p>
          <div>
            <p>The form can only be filled once and once submitted, if you try to fill again, it will discard the duplicate entries.</p>
            <p>The first page of the form covers the requirements we already discussed</p>
          </div>
          <TAForm />
        </section>
      </React.Fragment>
    );
  }
}
